import '@consumer-bootstrap/index.scss';
import '@consumer-bootstrap/pages/account-home/footer.scss';

export const SecurityWidgets = () => {
  return (
    <div className="security-widgets">
      <div id="trustedsite-trustmark" className="trustedsite-trustmark" data-height="48" data-type="301" data-width="140" />
      <script id="trustedsite" type="text/javascript" src="https://cdn.ywxi.net/js/1.js" defer />
    </div>
  );
};
